"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DrawablePropertiesComponent = void 0;
const core_shared_1 = require("@ikegps/core-shared");
const distance_input_1 = require("../../components/input/distance.input");
const distance_input_state_1 = require("../../components/input/distance.input.state");
const input_1 = require("../../components/input/input");
const input_state_1 = require("../../components/input/input.state");
const mithril_component_1 = require("../../components/mithril.component");
const modal_service_1 = require("../../components/modal/modal.service");
const modal_style_1 = require("../../components/modal/modal.style");
const theme_1 = require("../../components/theme");
const i18n_1 = require("../../i18n");
const mithril_1 = require("../../mithril");
const CSS = {
    content: 'c-DrawableProperties',
    title: 'c-DrawableProperties__Title',
};
(0, theme_1.addStyles)({
    [CSS.content]: {
        'min-height': theme_1.DefaultTheme.space(20),
    },
    [CSS.title]: {
        'font-weight': 'bold',
        'padding-bottom': theme_1.DefaultTheme.space(4),
    },
});
class DrawablePropertiesComponent extends mithril_component_1.IMithrilStateComponent {
    constructor(drawable) {
        super();
        this.isBase = false;
        if (core_shared_1.CollectionModelDrawableMarker.isBase(drawable)) {
            this.offsetState = new distance_input_state_1.DistanceInputState(i18n_1.T.DRAWABLE_BASE_OFFSET);
            this.offsetState.setValue(drawable.offset || 0);
            this.offsetState.isAutoFocused = true;
            this.isBase = true;
            this.state = this.offsetState;
        }
        else if (core_shared_1.CollectionModelDrawableLine.isLine(drawable) || core_shared_1.CollectionModelDrawableMarker.isMarker(drawable)) {
            this.state = new input_state_1.InputState(i18n_1.T.DRAWABLE_TITLE);
            this.state.setValue(drawable.label.text[0] || '');
            this.state.isAutoFocused = true;
            this.state.isLabelShown = false;
            this.state.name = 'marker-label';
        }
    }
    get isValid() {
        return this.state != null;
    }
    get nodes() {
        let content = null;
        if (this.isBase) {
            content = distance_input_1.DistanceInput.view(this.offsetState);
        }
        else {
            content = input_1.Input.view(this.state);
        }
        return (0, mithril_1.m)('div', { className: CSS.content }, [
            (0, mithril_1.m)('div', { className: CSS.title }, (0, i18n_1.Translate)(this.state.label)),
            content,
        ]);
    }
    viewActions() {
        const disabled = this.state.hasError();
        return (0, mithril_1.m)('div', { className: modal_style_1.CSS.actions }, [
            (0, mithril_1.m)('button', {
                className: 'mdl-button ' + modal_style_1.CSS.action.cancel,
                type: 'button',
                onclick: () => modal_service_1.ModalService.close(false),
            }, (0, i18n_1.Translate)(i18n_1.T.CANCEL)),
            (0, mithril_1.m)('button', { className: 'mdl-button mdl-button--accent ' + modal_style_1.CSS.action.ok, disabled, type: 'submit' }, (0, i18n_1.Translate)(i18n_1.T.OK)),
        ]);
    }
    open() {
        return modal_service_1.ModalService.open({
            title: i18n_1.T.SETTINGS_TITLE,
            onSubmit: () => modal_service_1.ModalService.close(true),
            content: () => this.nodes,
            actions: () => this.viewActions(),
        });
    }
}
exports.DrawablePropertiesComponent = DrawablePropertiesComponent;
//# sourceMappingURL=drawable.properties.js.map